module.exports = __webpack_public_path__ + "static/media/chess.639d0a98.png";